export default __webpack_public_path__ + "static/media/idosos.4cdbd700.jpg";